import React__default from 'react';

const DEFAULT_SVG_ATTRS = {
    'aria-hidden': true,
    focusable: false
};
const PlayIcon = () => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("svg", { width: '80', height: '80', viewBox: '0 0 80 80', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            React__default.createElement("circle", { cx: '40', cy: '40', r: '39', fill: '#0A0A0A', "fill-opacity": '0.26', stroke: 'white', "stroke-width": '2' }),
            React__default.createElement("path", { d: 'M32 26.1436L56 40L32 53.8564L32 26.1436Z', stroke: 'white', "stroke-width": '2' }))));
};
const CloseIcon = (props) => {
    const attrs = Object.assign(Object.assign({}, DEFAULT_SVG_ATTRS), props);
    return (React__default.createElement("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', width: '15', height: '15', fill: 'none', viewBox: '0 0 15 15' }, attrs),
        React__default.createElement("path", { fill: 'currentColor', "fill-rule": 'evenodd', d: 'M.293 14.435c.39.39 1.024.39 1.414 0l5.657-5.657 5.657 5.657c.39.39 1.023.39 1.414 0 .39-.39.39-1.024 0-1.414L8.778 7.364l5.657-5.657c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0L7.364 5.95 1.707.293c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414L5.95 7.364.293 13.021c-.39.39-.39 1.023 0 1.414z', "clip-rule": 'evenodd' })));
};

export { CloseIcon, PlayIcon };
//# sourceMappingURL=Svgs.js.map
